import { cn } from '@/lib/utils';

import { Text } from '@/components/atoms/Text';

import { ReviewItem } from '../types';
import { BentoDarkCard } from './BentoDarkCard';
import { StarRating } from './StarRating';

export function ReviewCard({ review }: { review: ReviewItem }) {
  return (
    <BentoDarkCard
      className={cn(
        'flex shrink-0 flex-col gap-4',
        // fixed design width — shrink-0 so the flex row scrolls instead of compressing
        'w-[268px]'
      )}
    >
      <div className='flex flex-col gap-3'>
        <div className='flex flex-col gap-4'>
          <StarRating rating={review.rating} />
          <Text
            variant='body-l-medium'
            color='gray-dark-300'
            classNames={{ wrapper: 'break-words font-serif' }}
          >
            {review.title}
          </Text>
        </div>
        <Text
          variant='body-m'
          color='gray-dark-500'
          classNames={{ wrapper: 'break-words' }}
        >
          {review.body}
        </Text>
      </div>

      <div className='border-t border-gray-dark-700 pt-4'>
        <div className='flex min-w-0 flex-col'>
          <Text
            variant='body-s-bold'
            color='gray-dark-300'
            classNames={{ wrapper: 'break-words font-serif' }}
          >
            {review.authorName}
          </Text>
          {review.authorRole && (
            <Text
              variant='body-s'
              color='gray-dark-400'
              classNames={{ wrapper: 'break-words font-serif' }}
            >
              {review.authorRole}
            </Text>
          )}
        </div>
      </div>
    </BentoDarkCard>
  );
}
